import styled from 'styled-components';
import { Typography } from '@/components/UI/Typography/Typography.styles';
import { ellipsisMultiline } from '@/styles/helpers';
import { CustomLink } from '@/components/CustomLink/CustomLink';

export const Box = styled(CustomLink)`
  padding: 15px;
  background-color: ${({ theme }) => theme.palette.secondary.background};
  display: flex;
  align-items: center;
  gap: 10px;
`;

export const Logo = styled.img`
  border-radius: 7px;
  width: 60px;
  aspect-ratio: 1;
`;

export const Texts = styled.div`
  flex-grow: 1;
  display: grid;
  gap: 2px;
`;

export const Name = styled(Typography.Header)`
  ${ellipsisMultiline(1)}
`;

export const Description = styled(Typography.Body)`
  ${ellipsisMultiline(2)}
  color: ${({ theme }) => theme.palette.secondary.labels};
`;
